import React from 'react';
export function Footer() {
  return <footer className="bg-brand-navyDeep px-4 py-3.5 text-center text-[10px] font-medium leading-snug text-white/60 sm:px-6 sm:text-[11px]" data-id="element-59" data-mp="32wd2qgad7ltj">
      <p className="mb-1 font-heading font-extrabold uppercase text-white/80" data-id="element-60" data-mp="32o4b2ak1486j">
        © 2026 PADEL MASTER PRO™ — Tutti i Diritti Riservati.
      </p>
      <p className="mx-auto mb-1.5 max-w-xl" data-id="element-61" data-mp="36pza18ehm9h5">
        Le informazioni e i materiali contenuti in questo sistema rappresentano risorse professionali
        di supporto destinate a istruttori, maestri e allenatori di padel. Non sostituiscono la
        preparazione professionale, il giudizio tecnico o la responsabilità dell’istruttore. Ogni
        sessione, esercizio, progressione, programma o strumento deve essere adattato al livello
        tecnico, alle capacità individuali, agli obiettivi e alle esigenze specifiche di ogni
        giocatore o gruppo.
      </p>
      <p className="mb-1" data-id="element-62" data-mp="2eyjpdjwhqwtk">
        <a href="mailto:kitonline27@gmail.com" className="font-bold hover:text-brand-green" data-id="element-63" data-mp="2ezut5jpxs4ko">
          kitonline27@gmail.com
        </a>
      </p>
      <nav aria-label="Link legali" className="flex justify-center gap-2 font-bold" data-id="element-64" data-mp="3gapbneqg0cdv">
        <a href="#" className="hover:text-brand-green" data-id="element-65" data-mp="3gctmyhqo8do6">
          Termini e Condizioni
        </a>
        <span data-id="element-66" data-mp="3v5dhwv3o3euj">•</span>
        <a href="#" className="hover:text-brand-green" data-id="element-67" data-mp="3q83tnis0l98a">
          Privacy Policy
        </a>
        <span data-id="element-68" data-mp="82qt3uy8hxus">•</span>
        <a href="#" className="hover:text-brand-green" data-id="element-69" data-mp="828qmgkzanef">
          Contatti
        </a>
      </nav>
    </footer>;
}